import {
  GET_EVENT_ID_REQUEST,
  GET_EVENT_ID_SUCCESS,
  GET_EVENT_ID_FAILURE,
  GET_EVENT_ID_RESET,
} from "../../../Utils/Constant";

const initialState = {
  data: {},
  loading: false,
  error: null,
};
export const getEventIDReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_EVENT_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_EVENT_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_EVENT_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      case GET_EVENT_ID_RESET:
      return {
        ...state,
        data: {
          event: {},
          report: {},
        },
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};
